import React, { useContext } from 'react';
import {
	ICustomerFullInfoContext,
	CustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';
import { useTranslation } from 'react-i18next';
import FullInfoField from 'components/FullInfoField/FullInfoField';

export const ShowLoyaltyProgramButtonsField: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);
	const { t } = useTranslation('form');
	const isChecked = customerForFullInfo?.isShowLoyaltyProgramButtons;
	const inputValue = isChecked ? t('yes') : t('no');

	return (
		<FullInfoField
			label="showLoyaltyProgramButtonsLabel"
			value={inputValue}
			prefixIcon="asCheckbox"
			prefixIconName={isChecked ? 'checkMark' : 'crossMark'}
			prefixIconIsChecked={isChecked}
		/>
	);
};
